export const Compressor = (file, quality = 0.8) => {
  return new Promise((resolve) => {
    // Compressor options
    var options = {
        file: file,
        quality: quality,
        old_size: 0,
        old_file: null,

        // Compressor before callback
        beforeCompress: function (result) {
          options.old_size = result.size
          options.old_file = result
          console.log('Before size: ', result.size)
          console.log('Before type: ', result.type)
        },

        // Canvas after callback
        afterDraw: function (ctx, canvas) {
          ctx.restore()
        },

        // Compressor success callback
        success: function (result) {
          if(options.old_size < result.size) {
            resolve(options.old_file)
          }
          console.log('After size: ', result.size)
          console.log('After type: ', result.type)
          console.log(
            'Compressor rate ',
            (((file.size - result.size) / file.size) * 100).toFixed(2) + '%'
          )
          // Blob convert file
          const newFile = new window.File([result], result.name, {
            type: result.type
          })
         
          // return new file
          resolve(newFile)
        },
    }

    // Call compressor api 
    new ImageCompressor(options)
  })
}